import { mockUpdates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            漫画更新、新作上架、平台动态 — 第一时间掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {mockUpdates.map((item, idx) => (
            <div
              key={idx}
              className={`relative flex gap-4 md:gap-6 ${
                idx < mockUpdates.length - 1 ? 'pb-6 md:pb-8' : ''
              }`}
            >
              <div className="flex flex-col items-center">
                <div className={`w-3 h-3 rounded-full flex-shrink-0 mt-1.5 ${
                  item.tag === '最新更新' ? 'bg-primary-500' :
                  item.tag === '新作首发' ? 'bg-accent-500' :
                  item.tag === '番外特别' ? 'bg-accent-500' :
                  'bg-secondary-500'
                }`}></div>
                {idx < mockUpdates.length - 1 && (
                  <div className="w-0.5 flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>
              <div className="flex-1 min-w-0 pb-1">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className={`inline-block px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${
                    item.tag === '最新更新' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '新作首发' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '番外特别' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}